import React from 'react';
import { Button } from 'react-bootstrap';

export class ServerRelease extends React.PureComponent {
    state = {
        loading: true,
        release: null,
        commit: null,
        settingCommit: false,
        versionCode: null,
        originalVersionCode: null
    };

    componentDidMount() {
        this.reload();
        this.queryVersion();
    }

    reload() {
        fetch('/api/server/release')
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ loading: false, error: result.error });
                } else {
                    this.setState({ loading: false, release: result.release, commit: result.release.commit });
                }
            });

    }

    onChangeCommit = e => {
        this.setState({ commit: e.target.value.trim() });
    }

    startChangeCommit = () => {
        this.setState({ settingCommit: true });
        fetch('/api/server/release/commit', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                commit: this.state.commit,
            }),
        }).then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ settingCommit: false, error: result.error });
                } else {
                    this.setState({ settingCommit: false, loading: true });
                    this.reload();
                }
            });
    }

    queryVersion = () => {
        fetch(`/api/data/client_version`)
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ error: result.error });
                } else {
                    this.setState({
                        versionCode: result.version,
                        originalVersionCode: result.version
                    });
                }
            });
    }

    onChangeVersion = e => {
        this.setState({ versionCode: e.target.value });
    }

    saveVersion = () => {
        fetch(`/api/data/client_version`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                version: this.state.versionCode,
            }),
        })
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ error: result.error });
                } else {
                    this.queryVersion();
                }
            });
    }


    render() {
        if (this.state.loading) {
            return <div>Loading...</div>;
        }
        return (<div>
            <h1>Server Release</h1>
            <table>
                <tbody>
                    <tr>
                        <td>Commit</td>
                        <td>
                            <input value={this.state.commit} onChange={this.onChangeCommit} />
                            {
                                this.state.commit && this.state.commit !== this.state.release.commit &&
                                <Button onClick={this.startChangeCommit}>Set</Button>
                            }
                        </td>
                    </tr>
                    {
                        this.state.release.status && Object.keys(this.state.release.status).map(key => {
                            const value = this.state.release.status[key];
                            const component = typeof value === 'string' && value.startsWith("http") ? <a href={value}>{value}</a> : value;
                            return (<tr key={key}>
                                <td>{key}</td>
                                <td>
                                    {component}
                                </td>
                            </tr>);
                        })
                    }
                    <tr>
                        <td>Newest Client Version on Store</td>
                        <td>
                            <input value={this.state.versionCode} onChange={this.onChangeVersion} />
                            {
                                this.state.versionCode && this.state.originalVersionCode !== this.state.versionCode &&
                                <Button onClick={this.saveVersion}>Set</Button>
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>);
    }
}
